import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PiNewspaperDuotone } from 'react-icons/pi'
import api from '../helpers/Api';
import Loading from '../components/Loading';
import { SkeletonHomeNews } from '../components/Skeleton';

export function Render({ news }) {
    const navigate = useNavigate()

    const getImageUrl = (item) => {
        const img = item.images?.[0];
        if (img?.id) return `${api.defaults.baseURL}/news-image-proxy?id=${img.id}`;
        if (img?.image_url) return img.image_url;
        if (item.imagenPrincipalId) return `${api.defaults.baseURL}/news-image-proxy?id=${item.imagenPrincipalId}`;
        if (item.imagenPrincipal) return item.imagenPrincipal;
        return null;
    };

    return (
        <div className="bg-[#0a0a0f] py-16 px-4">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-10">
                    <span className="text-brand font-mono font-semibold text-sm uppercase tracking-widest">Blog</span>
                    <h2 className="text-white font-display font-bold text-3xl sm:text-4xl mt-2">Últimas Noticias</h2>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {news.map((item, index) => {
                        const img = getImageUrl(item);
                        return (
                        <div
                            key={index}
                            className="group flex flex-col bg-[#16151c] border border-white/10 hover:border-brand/30 rounded-2xl overflow-hidden transition-all duration-300 shadow-xl cursor-pointer"
                            onClick={() => navigate(`/news/detail/${item.id}`)}
                        >
                            <div className="relative h-44 overflow-hidden bg-[#0f0e17]">
                                {img ? (
                                    <img
                                        src={img}
                                        alt={item.title}
                                        className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                        onError={(e) => { e.target.style.display = "none"; }}
                                    />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center">
                                        <PiNewspaperDuotone className="text-gray-700 text-5xl" />
                                    </div>
                                )}
                                <div className="absolute inset-0 bg-gradient-to-t from-[#16151c] via-transparent to-transparent opacity-60" />
                            </div>
                            <div className="p-5 flex flex-col gap-2 flex-1">
                                <h5 className="text-base font-bold text-white leading-tight line-clamp-2">
                                    {item.title}
                                </h5>
                                <p className="text-gray-400 text-xs leading-relaxed line-clamp-3 flex-1">
                                    {item.content_new || "Sin descripción."}
                                </p>
                                <button
                                    onClick={(e) => { e.stopPropagation(); navigate(`/news/detail/${item.id}`); }}
                                    className="mt-3 event-one__btn thm-btn w-full text-sm"
                                >
                                    Leer más
                                </button>
                            </div>
                        </div>
                    );
                    })}
                </div>
            </div>
        </div>
    )
}

export default function News() {
    const [news, setNews] = useState(null);

    useEffect(() => {
        api.get(`/NewsEvent`).then(r => setNews(r.data)).catch(() => setNews(null));
    }, []);

    if (news === null) return <SkeletonHomeNews />;
    if (news.length === 0) return null;
    return <Render news={news} />;
}
